// filepath: apps/web/src/features/admin/forms/FormsListPage.tsx
//
// FR-UI-BLD-1 / ISS-f4fa1b7b-258 - empty-state placeholder for the
// form-definition list page. The list-table functionality is
// tracked for a follow-up FR; this page ships with the route so the
// /admin/forms navigation works end-to-end.

import React from "react";
import { useTranslation } from "react-i18next";

export function FormsListPage(): React.ReactElement {
  const { t } = useTranslation();
  return (
    <div
      className="forms-list-page"
      data-testid="forms-list-page"
      role="region"
      aria-label={t("admin.forms.list.aria")}
    >
      <h1 className="forms-list-page__title">{t("admin.forms.list.title")}</h1>
      <p className="forms-list-page__empty" data-testid="forms-list-page-empty">
        {t("admin.forms.list.empty")}
      </p>
    </div>
  );
}
